import { createEnv } from '@t3-oss/env-nextjs';
import { z } from 'zod';

export const env = createEnv({
  server: {
    AUTH_TOKEN_SENTRY: z.string().min(1),
  },
  client: {
    NEXT_PUBLIC_GRAPHQL_URI: z.string().min(1).url(),
    NEXT_PUBLIC_MAGNETO_GRAPHQL_URI: z.string().min(1).url(),
    NEXT_PUBLIC_MAGNETO_URI: z.string().min(1).url(),
    NEXT_PUBLIC_SENTRY_DSN: z.string().min(1).url(),
    NEXT_PUBLIC_ENVIRONMENT: z.enum(['development', 'test', 'production']),
    NEXT_PUBLIC_BASE_URL: z.string().min(1).url(),
    NEXT_PUBLIC_SOCKET_URL: z.string().min(1).url(),
    NEXT_PUBLIC_ALERTS_URL: z.string().min(1),
    NEXT_PUBLIC_GOOGLE_MAP_KEY: z.string().min(1),
    NEXT_PUBLIC_CODE_CLIENT: z.string().min(1),
    NEXT_PUBLIC_PRODUCT_CODE: z.string().min(1),
    NEXT_PUBLIC_PORTAL_TRIBUTARIO: z.string().min(1),
    NEXT_PUBLIC_RECAPTCHA_SITE_KEY_V3: z.string().min(1),
    NEXT_PUBLIC_CODEGEN_TOKEN: z.string().min(1),
    NEXT_PUBLIC_MAGNETO_PRODUCT_ID: z.string().min(1),
    NEXT_PUBLIC_MAGNETO_ORGANIZATION_ID: z.string().min(1),
    //Google
    NEXT_PUBLIC_GOOGLE_CLIENT_ID: z.string().min(1),
  },
  runtimeEnv: {
    AUTH_TOKEN_SENTRY: process.env.AUTH_TOKEN_SENTRY,
    NEXT_PUBLIC_ALERTS_URL: process.env.NEXT_PUBLIC_ALERTS_URL,
    NEXT_PUBLIC_SOCKET_URL: process.env.NEXT_PUBLIC_SOCKET_URL,
    NEXT_PUBLIC_GRAPHQL_URI: process.env.NEXT_PUBLIC_GRAPHQL_URI,
    NEXT_PUBLIC_MAGNETO_GRAPHQL_URI: process.env.NEXT_PUBLIC_MAGNETO_GRAPHQL_URI,
    NEXT_PUBLIC_SENTRY_DSN: process.env.NEXT_PUBLIC_SENTRY_DSN,
    NEXT_PUBLIC_ENVIRONMENT: process.env.NEXT_PUBLIC_ENVIRONMENT,
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PUBLIC_GOOGLE_MAP_KEY: process.env.NEXT_PUBLIC_GOOGLE_MAP_KEY,
    NEXT_PUBLIC_MAGNETO_URI: process.env.NEXT_PUBLIC_MAGNETO_URI,
    NEXT_PUBLIC_CODE_CLIENT: process.env.NEXT_PUBLIC_CODE_CLIENT,
    NEXT_PUBLIC_PRODUCT_CODE: process.env.NEXT_PUBLIC_PRODUCT_CODE,
    NEXT_PUBLIC_PORTAL_TRIBUTARIO: process.env.NEXT_PUBLIC_PORTAL_TRIBUTARIO,
    NEXT_PUBLIC_RECAPTCHA_SITE_KEY_V3: process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY_V3,
    NEXT_PUBLIC_CODEGEN_TOKEN: process.env.NEXT_PUBLIC_CODEGEN_TOKEN,
    NEXT_PUBLIC_MAGNETO_PRODUCT_ID: process.env.NEXT_PUBLIC_MAGNETO_PRODUCT_ID,
    NEXT_PUBLIC_MAGNETO_ORGANIZATION_ID: process.env.NEXT_PUBLIC_MAGNETO_ORGANIZATION_ID,
    //Google
    NEXT_PUBLIC_GOOGLE_CLIENT_ID: process.env.NEXT_PUBLIC_GOOGLE_CLIENT_ID,
  },
});
